import React, {useState, useEffect} from 'react';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import Collapse from '@material-ui/core/Collapse';
import CloseIcon from '@material-ui/icons/Close';
import trackAnalytics from '../../utils/gaia/trackAnalytics';
import {
    getLocalStorageItem,
    setLocalStorageItem,
} from '../../utils/localStorage';
import theme from '../../theme';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import {makeStyles} from '@material-ui/core/styles';

const useButtonClasses = makeStyles({
    root: {
        '&:hover': {
            color: 'inherit !important',
        },
    },
});

interface AnnouncementProps {
    analyticsEvent: 'winter_gift' | 'volunteers' | 'dei';
    href: string;
    buttonText: string;
    children: string;
    style?: React.CSSProperties;
}

export default function Announcement({
    analyticsEvent,
    href,
    buttonText,
    children,
    style,
}: AnnouncementProps) {
    const localStorageKey = `announcement__${analyticsEvent}`;

    const [isOpenState, setIsOpenState] = useState<boolean>(
        getLocalStorageItem(localStorageKey, true)
    );

    useEffect(() => setLocalStorageItem(localStorageKey, isOpenState), [
        isOpenState,
        localStorageKey,
    ]);

    const isNarrow = useMediaQuery(theme.breakpoints.down('xs'));

    const disallowedUrls = [href, '/map/', '/web_discounts/', '/save40/'];

    const isOpen =
        !disallowedUrls.includes(window.location.pathname) && isOpenState;

    const buttonClasses = useButtonClasses();

    return (
        <Collapse in={isOpen}>
            <Paper
                square
                style={{
                    color: '#fff',
                    paddingTop: theme.spacing(1.5),
                    paddingBottom: theme.spacing(1.5),
                    paddingLeft: 51,
                    paddingRight: 51,
                    display: 'flex',
                    alignItems: isNarrow ? 'center' : 'baseline',
                    justifyContent: 'center',
                    flexDirection: isNarrow ? 'column' : 'row',
                    ...style,
                }}
            >
                <IconButton
                    style={{
                        position: 'absolute',
                        right: theme.spacing(1),
                        alignSelf: 'center',
                    }}
                    color='inherit'
                    onClick={() => setIsOpenState(false)}
                >
                    <CloseIcon />
                </IconButton>

                <span style={{fontSize: 15}}>{children}</span>

                <Button
                    classes={buttonClasses}
                    component='a'
                    size='medium'
                    style={{
                        fontSize: 13,
                        marginLeft: isNarrow ? 0 : theme.spacing(2),
                        marginTop: isNarrow ? theme.spacing(2) : 0,
                    }}
                    variant='outlined'
                    color='inherit'
                    onClick={() => {
                        trackAnalytics('Click Banner', {
                            category: 'Commerce',
                            url: window.location.pathname,
                            banner_type: analyticsEvent,
                        });
                        setIsOpenState(false);
                    }}
                    href={href}
                >
                    {buttonText}
                </Button>
            </Paper>
        </Collapse>
    );
}
